import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import { MDText } from 'i18n-react';

import useLoadExternalScripts from 'Utilities/hooks/useLoadScripts';

import { Content } from 'LegacySBCRA/Content/Content';

import { stripStringAndCamelCase } from '../../../../utilities/index';
import { SEO_PAGES_EXTERNAL_URL } from '../helpers';
import contentConfig from '../SeoPagesContentConfig';
import SeoPageHeader from '../SeoPagesHeader/SeoPageHeader';
import LocalTexts from '../SeoPagesTexts.json';

import styles from './SeoPage.scss';

const LocalT = new MDText(LocalTexts);

// https://isotropic.co/how-to-fix-the-property-does-not-exist-on-type-window-error-in-typescript/
declare global {
  interface Window {
    jQuery: any;
  }
}

const SeoPage = () => {
  const scripts = [
    `${SEO_PAGES_EXTERNAL_URL}/lib/jquery.min.js?v21.2'`,
    `${SEO_PAGES_EXTERNAL_URL}/lib/tooltips.js`,
    `${SEO_PAGES_EXTERNAL_URL}/lib/jquery.dataTables.min.js`,
    `${SEO_PAGES_EXTERNAL_URL}/js/app.js`,
  ];

  const { handleExternalScript, success } = useLoadExternalScripts();

  useEffect(() => {
    handleExternalScript({ isAsync: false, scripts });
  }, []);

  useEffect(() => {
    if (success) {
      window?.jQuery('#motorway_ev_index_table').DataTable({
        info: !1,
        language: {
          paginate: {
            next: '>', previous: '<',
          },
        },
        order: [[2, 'desc']],
        searching: !1,
      });
    }
  }, [success]);

  const { pathname } = useLocation();
  const pageContent = contentConfig.find((c) => c.id === stripStringAndCamelCase(pathname));

  if (!pageContent) {
    return <Content center><p>{LocalT.translate('error')}</p></Content>;
  }

  return (
    <>
      <SeoPageHeader content={pageContent?.header} />
      <div className={styles.component}>
        <div dangerouslySetInnerHTML={{ __html: pageContent?.main }} id="seoPage" />
      </div>
    </>
  );
};

export default SeoPage;
